module.exports = __webpack_public_path__ + "static/img/tiyan.fdb411f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service/tiyan.png
// module id = yO7v
// module chunks = 4